<template>
  <section class="about-children">
    <div :class="['about-children__wrapper', customBackground]">
      <template>
        <BaseTitle class="about-children__title" :text="titleText" />
        <div class="about-children__text">
          <div class="about-children__container">
            <BaseText class="about-children__descr" :text="text" />
          </div>
        </div>
        <ul class="about-children__list">
          <li v-if="questionnaireDocUrl" class="about-children__item">
            <BaseDownloadBtn
              class="about-children__btn"
              :customClass="'default'"
              :text="applicationText"
              :href="`${RESOURCES_URL}${questionnaireDocUrl}`"
              download
              target="_blank"
            />
          </li>
          <li class="about-children__item" v-bind:class="{'full_width': !questionnaireDocUrl}" >
           <BaseBtn
              class="about-children__btn"
              :class="{'btn--disabled': questionnaireDisabled}"
              :customClass="'default'"
              :text="questionnaireText"
              :to="'/request-form'"
            />
          </li>
          <li class="about-children__item">
            <BaseBtn
              class="about-children__btn"
              :customClass="'default-text'"
              :text="questionnaireButton"
              :to="'/terms'"
            />
          </li>
        </ul>
      </template>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseDownloadBtn from '~/components/_UI/BaseDowloadBtn.vue'

export default {
  name: 'AboutWorldContest',
  props: {
    customBackground: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      origin: ''
    }
  },
  computed: {
    titleText() {
      return this.messages.about.aboutWorldContest.title
    },
    text() {
      return this.messages.about.aboutWorldContest.text
    },
    questionnaireButton() {
      return this.messages.about.aboutWorldContest.questionnaireButton
    },
    applicationText() {
      return this.messages.about.aboutWorldContest.application.buttonText
    },
    applicationDocUrl() {
      return this.messages.about.aboutWorldContest.application.docUrl
    },
    questionnaireDocUrl() {
      return this.messages.about.aboutWorldContest.questionnaire.docUrl
    },
    questionnaireDisabled() {
      return this.messages.about.aboutWorldContest.questionnaire.disabled
    },
    questionnaireText() {
      return this.messages.about.aboutWorldContest.questionnaire.buttonText
    },
    ...mapGetters('data', ['RESOURCES_URL'])
  },
  components: {
    BaseDownloadBtn
  },
  mounted() {
    this.origin = window.location.origin
  }
}
</script>

<style lang="scss">
.about-children {
  &__wrapper {
    @include container;

    position: relative;

    &::before {
      content: '';
      position: absolute;
      z-index: -2;
    }

    &--first-block {
      padding: 0 16px 100px;

      &::before {
        bottom: 20px;
        left: 25px;
        width: 269px;
        height: 233px;
        background: url('~/static/img/about-children-bg@mb.png') no-repeat
          center;
        background-size: cover;
      }
    }

    &--second-block {
      padding: 0 16px 38px;

      &::before {
        bottom: 170px;
        right: -150px;
        width: 250px;
        height: 194px;
        background: url('~/static/img/about-children-bg-2@mb.svg') no-repeat
          center;
        background-size: cover;
      }
    }
  }

  &__title {
    margin: 0 0 20px;
  }

  &__descr {
    margin: 0;

    &:not(:last-of-type) {
      margin-bottom: 20px;
    }
  }

  &__text {
    margin-bottom: 40px;
  }

  &__list {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  &__item {
    text-align: center;

    &:not(:last-of-type) {
      margin-bottom: 20px;
    }
  }

  &__item.full_width {
    width: 100%;

    .about-children__btn {
      width: 100%;
    }
  }

  &__btn {
    min-width: 164px;

    &.btn--disabled {
      pointer-events: none;
      opacity: 0.4;
    }
  }
}

@include media-min($tablet-width) {
  .about-children {
    $parent: &;

    &__wrapper {
      &--first-block {
        padding: 0 25px 100px;

        &::before {
          right: 90px;
          bottom: 0;
          left: initial;
        }

        #{$parent}__container {
          display: flex;
        }

        #{$parent}__descr {
          flex-grow: 1;
          flex-basis: 45%;

          &:not(:last-of-type) {
            margin: 0 24px 0 0;
          }
        }
      }

      &--second-block {
        padding: 0 25px 70px;

        &::before {
          top: -6px;
          right: -120px;
          bottom: initial;
          left: initial;
        }

        #{$parent}__text {
          margin-bottom: 40px;
        }

        #{$parent}__list {
          display: flex;
          justify-content: space-between;
          align-content: space-between;
          flex-wrap: wrap;
          width: 400px;
          height: 132px;
        }

        #{$parent}__item {
          &:not(:last-of-type) {
            margin: 0;
          }

          &:last-of-type {
            flex-grow: 1;

            #{$parent}__btn {
              width: 100%;
            }
          }
        }
      }
    }

    &__title {
      margin-bottom: 35px;
    }
  }
}

@include media-min($desktop-width) {
  .about-children {
    $parent: &;

    &__wrapper {
      &--first-block {
        padding: 0 60px 150px;

        &::before {
          right: -250px;
          bottom: -130px;
          width: 1711px;
          height: 609px;
          background: url('~/static/img/about-children-bg@dt.svg') no-repeat
            center;
          background-size: cover;
        }

        #{$parent}__descr {
          &:not(:last-of-type) {
            margin-right: 40px;
          }
        }
      }

      &--second-block {
        display: flex;
        flex-wrap: wrap;
        padding: 0 60px 98px;

        &::before {
          right: -270px;
          top: -60px;
          width: 1730px;
          height: 505px;
          background: url('~/static/img/about-children-bg-2@dt.svg') no-repeat
            center;
          background-size: cover;
        }

        #{$parent}__title {
          width: 100%;
          margin-bottom: 40px;
        }

        #{$parent}__text {
          width: 560px;
          margin: 0 80px 0 0;
        }

        #{$parent}__list {
          width: 440px;
        }

        #{$parent}__btn {
          width: 174px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/AboutWorldContest.vue